if (!customElements.get('ks-bf-stock')) {
  class KsBfStock extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      const variants = this.querySelector('[data-bf-variants]');
      const strings = this.querySelector('[data-bf-strings]');
      if (!variants || !strings) return;
      this.variants = new Map(JSON.parse(variants.textContent).map(variant => [String(variant.id), variant]));
      this.strings = JSON.parse(strings.textContent);
      this.threshold = Number(this.dataset.threshold) || 10;
      this.scope = this.closest('.m-product-info--wrapper') || this.closest('[data-section-id]') || this.parentElement;
      this.abortController = new AbortController();
      this.scope.addEventListener('change', event => {
        if (event.target.name === 'id') this.update(event.target.value);
        else if (event.target.closest('variant-picker')) {
          queueMicrotask(() => {
            const input = this.scope.querySelector('product-form input[name="id"]');
            if (input) this.update(input.value);
          });
        }
      }, { signal: this.abortController.signal });
      const picker = this.scope.querySelector('variant-picker');
      if (this.variants.size > 1 && picker?.dataset.disableSelectedVariantDefault === 'true' && !new URL(window.location.href).searchParams.has('variant')) this.update('');
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    update(id) {
      const variant = this.variants.get(String(id));
      const text = this.strings;
      let state = 'normal';
      let message = text.limited;
      let detail = text.terms;
      let showCount = false;
      let showUrgency = false;
      this.hidden = !!variant && !variant.offer;
      if (!variant) {
        message = text.offer;
        detail = text.choose;
      } else if (!variant.available) {
        state = 'soldout';
        message = text.soldout;
        detail = text.soldoutDetail;
      } else if (!variant.tracked || variant.policy === 'continue') {
        message = text.offer;
        detail = text.selection;
      } else if (variant.quantity > 0 && variant.quantity <= this.threshold) {
        showCount = true;
        state = variant.quantity <= 3 ? 'last' : 'low';
        const format = variant.quantity === 1 ? text.lastOne : variant.quantity <= 3 ? text.lastFew : text.remaining;
        message = format.replace('__quantity__', variant.quantity);
      } else if (variant.quantity > this.threshold) {
        showUrgency = true;
      }
      this.dataset.bfState = state;
      this.dataset.variantId = variant ? String(variant.id) : '';
      this.querySelector('[data-bf-message]').textContent = message;
      this.querySelector('[data-bf-detail]').textContent = detail;
      const count = this.querySelector('[data-bf-count]');
      const unit = this.querySelector('[data-bf-unit]');
      count.hidden = !showCount;
      unit.hidden = !showCount;
      this.querySelector('[data-bf-urgency]').hidden = !showUrgency;
      const seal = this.querySelector('[data-bf-seal]');
      seal.hidden = !showCount && !showUrgency;
      seal.classList.toggle('ks-bf-stock__seal--offer', showUrgency);
      if (showCount) {
        count.textContent = variant.quantity;
        unit.textContent = variant.quantity === 1 ? text.unitOne : text.unitMany;
      }
      const variantLabel = this.querySelector('[data-bf-variant]');
      if (variantLabel) {
        variantLabel.hidden = !variant;
        if (variant) variantLabel.querySelector('span').textContent = variant.title;
      }
    }
  }
  customElements.define('ks-bf-stock', KsBfStock);
}
